import React from 'react';

const CollectionTags = ({ tags = [], isShowNew = false }) => {
	const getTagColors = () => {
		let myArray = ['green-1', 'pink-1'];
		let randomIndex = Math.floor(Math.random() * myArray.length);
		return myArray[randomIndex];
	};

	const renderTags = () => {
		return tags?.map((item) => {
			return (
				<span className={`status ${getTagColors()} mr-1`} key={`tag_${item.id}`}>
					{item.text}
				</span>
			);
		});
	};

	return (
		<div className="collection-status">
			{isShowNew && <span className={`status blue-3 mr-1`}>New</span>}
			{renderTags()}
		</div>
	);
};

export default CollectionTags;
